<script>
 import { static_page } from "../stores/store.js";
 </script>

<nav class="justify-center flex gap-4 my-4">
    <a class="{$static_page === "" ? "underline" : ""} text-fuchsia-400 font-mono text-xl hover:text-green-500 hover:underline" href="/">Episodes</a>
    <a class="{$static_page === "merch" ? "underline" : ""} text-fuchsia-400 font-mono text-xl hover:text-green-500 hover:underline" href="/merch">Merch</a>
    <a class="{$static_page === "drops" ? "underline" : ""} text-fuchsia-400 font-mono text-xl hover:text-green-500 hover:underline" href="/drops">Drops</a>
    <a class="{$static_page === "radio" ? "underline" : ""} text-fuchsia-400 font-mono text-xl hover:text-green-500 hover:underline" href="/radio">Radio</a>
</nav>
